<div>
	<app-dropdown-columns-actions
		[columns]="columns()"
		[translationPrefix]="'watchList.'"
		(columnsChange)="onChangeColumns($event)"
	/>
</div>
